import type { Plugin } from '@segment/analytics-next'

import { isSegmentDuplicateGuardEnabled } from './env'
import { createDuplicateGuardPlugin } from './guard'

// Dev-only Segment plugin: blocks identical tracks within DEDUPE_WINDOW_MS.
// Wired from segmentClient.ts — not part of Dev Notify diagnostics.
export { DEDUPE_WINDOW_MS } from './dedupe'
export { createDuplicateGuardPlugin } from './guard'
export {
  isSegmentDuplicateGuardDisabledByEnv,
  isSegmentDuplicateGuardEnabled,
} from './env'

export const getDuplicateGuardSegmentPlugins = (): Plugin[] =>
  isSegmentDuplicateGuardEnabled() ? [createDuplicateGuardPlugin()] : []
